import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-adminsales-orderstb',
  templateUrl: './adminsales-orderstb.component.html',
  styleUrls: ['./adminsales.component.css']
})
export class AdminsalesOrderstbComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private router: Router, 
  ) { }
  
  formIdProduct = this.fb.group({
    productsource : [''],
  });
  formOrderstb = this.fb.group({
    partnerid: [''],
    noorder: [''],
    nogrf: [''],
    noiom: [''],
    sales_name: [''],
    quota: [''],
    ordertype: [''],
    orderdate: [''],
    product: ['']
  })
  formProduct = this.fb.group({
    productid : [''],
    transactiontype: [''],
    note: [''],
    quota: ['']
  });

  btn_save = true
  btn_loading = false
  alert_failed = false
  alert_success = false
  alert_redirect = false
  alert_quota = false
  table_product_kosong = true
  table_product_data = false
  
  selectedProduct: any = []
  data_table_product: any = []
  data_productsource:any={}
  data_partner:any=[]
  data_product:any={}
  response_api:any={}
  partnerdetail:any={}

  count:number = 0
  sum:number = 0

  ordertypeValue=''
  loadspin=false

  ngOnInit() {
    this.LoadJsOrder.loadScriptOrderService()
    this.sourceProduct()
    this.partner()
  }
  refreshPage() {
    this.ngOnInit()
  }

  sourceProduct() {
    this.restApi.GetProductsource().subscribe((data: any) => { 
      this.data_productsource = data
      // console.log(this.data_productsource)
    });  
  }
  partner() {
    this.restApi.GetViewpartnerless().subscribe((output: any) => { 
      this.data_partner = output.data
    });  
  }
  partnerdtl() {
    let id = this.formOrderstb.value.partnerid
    this.restApi.GetViewpartnerdetail(id).subscribe((output: any) => { 
      this.partnerdetail = output.data
    });  
  }
  getIdProduct(e:any) {
    this.selectedProduct = []
    this.data_table_product = []
    this.formIdProduct.get('productsource').setValue(e.target.value);
    this.restApi.PostListProduct(this.formIdProduct.value).subscribe((data: {}) => { 
        this.data_product = data
        // console.log(this.data_product)
        for (let i = 0; i < this.data_product.data.length; i++) {
          // console.log(this.data_product.data[i].id);
          this.selectedProduct.push(
            {
              'id':this.data_product.data[i].id+'|'+this.data_product.data[i].productname,
              'name':this.data_product.data[i].productname
            }
          )
        }
        // console.log(this.selectedProduct)
      });  
  }

  remove(item:any) {
    this.data_table_product.splice(item, 1);
  }
  resetForm(){
    this.formProduct.reset()
  }
  resetTbl(){
    this.data_table_product = []

  }
  redirectListorder(params: any) {
    this.router.navigate([params]);
  }

  ordertype() {
    if (this.ordertypeValue  == "1") {
      
      // this.formRegister.get('partner').setValidators(this.formPartner['partner']);
      // this.formRegister.get('partner').setValue(""); 
      this.resetTbl()
    }
  }

  submitProduct() {
    this.data_table_product.forEach(element => {
      this.count = this.count + parseInt(element.quota)
      console.log(element)
    })

    this.sum = this.count + this.formProduct.get('quota').value
    console.log(this.sum, this.formProduct.get('quota').value)

    if (this.sum <= this.formOrderstb.get('quota').value) { //jika data cocok
      // console.log(this.formProduct.get('productid').value)
      let id = this.formProduct.get('productid').value.split('|');
      this.formProduct.get('productid').setValue(id[0]);
      this.data_table_product.push(
        {
          'product':id[1],
          'productid':id[0],
          'transactiontype':1,
          'quota':this.formProduct.get('quota').value,
          'note':this.formProduct.get('note').value
        }
      )
      this.resetForm()
      console.log(this.sum, 'masuk')
      // console.log(this.formProduct.value)
    }else if (this.sum > this.formOrderstb.get('quota').value) { //jika lebih
      console.log('lebih')  
      
      this.LoadJsOrder.loadScriptProductStb()
      this.alert_quota = true
      setTimeout(()=>{
        this.alert_quota = false
        this.count = 0
        this.sum = 0

      }, 3000);

    }else{ //jika gagal
      console.log('gagal')
      
      this.LoadJsOrder.loadScriptProductStb()
      this.alert_failed = true
      setTimeout(()=>{
        this.alert_failed = false
      }, 6000);
    }
  }

  submitOrderService(el: HTMLElement) {
    //let date = this.formOrderstb.get('orderdate').value
    //let orderdate = date.year+'-'+date.month+'-'+date.day
    //this.formOrderstb.get('orderdate').setValue(orderdate)
    
    
    this.formOrderstb.get('product').setValue(this.data_table_product)
    let count:number = 0
    this.data_table_product.forEach(element => {
      count = count + parseInt(element.quota)
      // console.log(element)
    })

    this.loadspin = true
    this.formOrderstb.disable()
    console.log(this.formOrderstb.value)
      if (count == this.formOrderstb.value.quota){
        // console.log("pas")
        this.restApi.PostCreateOrderstb(this.formOrderstb.value)
          .subscribe((data: any) => { 
            this.response_api = data
            console.log(data)
            if (this.response_api.status == true) {
            
              this.LoadJsOrder.loadScriptProductStb()
              this.alert_success = true
              setTimeout(()=>{
                el.scrollIntoView({behavior:"smooth"})
              }, 500);
      
              this.alert_redirect = true
              setTimeout(()=>{
                this.redirectListorder("adminsales/listorder");
              }, 5000);
            } else {

              this.LoadJsOrder.loadScriptProductStb()
              this.alert_failed = true
              setTimeout(()=>{
                this.alert_failed = false
              }, 6000);
            }
          }
        );
      }else{
        // console.log("jumlah quota stb harus sama dengan jumlah quota service")
        // setTimeout(()=>{
        //   el.scrollIntoView({behavior:"smooth"})
        // }, 500);
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_quota = true
        setTimeout(()=>{
          this.alert_quota = false
        }, 6000);
      }

  }

  submitOrderpaired(el: HTMLElement) {

    this.loadspin = true
    this.formOrderstb.disable()
    console.log(this.formOrderstb.value)
    this.restApi.PostCreateOrderpaired(this.formOrderstb.value)
      .subscribe((data: any) => { 
        this.response_api = data
        console.log(data)
        if (this.response_api.status == true) {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
  
          this.alert_redirect = true
          setTimeout(()=>{
            this.redirectListorder("adminsales/listorder");
          }, 5000);
        } else {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      }
    );
  }

}
